'use strict';
let initialized = false;
let tagID = null;
/**
 * The gtag function
 */
window.gtag = () => {
  throw 'gtag has not been embedded / initialized.';
};

/**
 * Global site tag (gtag.js) - Google Analytics
 * @param {String} trackingID The Google analytics tracking id
 */
export function embed(trackingID) {
  if (initialized) {
    throw 'Error, cannot embed gtagjs twice';
  }
  initialized = true;
  tagID = trackingID;
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingID}`;
  script.async = true;
  if (document.body) {
    document.body.appendChild(script);
  } else {
    document.head.appendChild(script);
  }
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
}

export default { embed, tagID };
